import React, { useEffect, useState } from "react";
import { Button, Form, Input, message } from "antd";
import IntlMessages from "util/IntlMessages";
import { useHistory, useLocation } from "react-router-dom";
import AuthService from "../services/auth.service";
import { useSelector } from "react-redux";

const FormItem = Form.Item;

function useQuery() {
	return new URLSearchParams(useLocation().search);
}

const ResetPassword = (props) => {
	const [form] = Form.useForm();
	let query = useQuery();
	const history = useHistory();
	const token = useSelector(({ auth }) => auth.token);

	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (token !== null) {
			props.history.push("/");
		}
	}, [token, props.history]);

	const onFinishFailed = (errorInfo) => {
		console.log("Failed:", errorInfo);
	};

	const onFinish = (values) => {
		if (query.get("token")) {
			setLoading(true);

			values.token = query.get("token");

			AuthService.ResetPassword(values)
				.then((response) => {
					message.success(response.data.message);
					history.push("signin");
				})
				.catch((err) => {
					if (typeof err.response.data.errors == "object") {
						let fields = [];

						for (const error in err.response.data.errors) {
							fields.push({
								name: error,
								errors: [err.response.data.errors[error]],
							});
						}

						form.setFields(fields);
					}

					if (err.response.data.message) {
						message.error(err.response.data.message);
					}
				})
				.finally(() => setLoading(false));
		}
	};

	return (
		<div className="gx-login-container">
			<div className="gx-login-content">
				<div className="gx-login-header">
					<img
						src={require("assets/images/logo.png")}
						alt="wieldy"
						title="wieldy"
					/>
				</div>
				<div className="gx-mb-4">
					<h2>Recuperar Contraseña</h2>
					<p>
						<IntlMessages id="appModule.enterPasswordReset" />
					</p>
				</div>

				<Form
					initialValues={{ remember: true }}
					name="basic"
					onFinish={onFinish}
					onFinishFailed={onFinishFailed}
					className="gx-signin-form gx-form-row0"
					form={form}
				>
					<FormItem
						rules={[{ required: true, message: "Please input your Email!" }]}
						name="email"
					>
						<Input
							className="gx-input-lineheight"
							type="email"
							placeholder="Correo electronico"
						/>
					</FormItem>

					<FormItem
						rules={[{ required: true, message: "Please input your Password!" }]}
						name="password"
					>
						<Input
							className="gx-input-lineheight"
							type="password"
							placeholder="Contraseña"
						/>
					</FormItem>

					<FormItem
						rules={[
							{ required: true, message: "Please confirm your password!" },
						]}
						name="password_confirmation"
					>
						<Input
							className="gx-input-lineheight"
							placeholder="Repetir Contraseña"
							type="password"
						/>
					</FormItem>

					<FormItem>
						<Button loading={loading} type="primary" htmlType="submit">
							<IntlMessages id="app.userAuth.reset" />
						</Button>
					</FormItem>
				</Form>
			</div>
		</div>
	);
};

export default ResetPassword;
